import React from 'react';
import style from './NotFound.module.css';

function NotFound() {
    return (
        <section className={style.NotFound}>
            <h1>Not Found 404</h1>
        </section>
    )
};

export default NotFound;
